import React from 'react'
import {PanelWrapper} from "./PanelWrapper";
import {Card} from "../Card";
import {isSelected, loadingSkeleton} from '../EntitySelectorModal.helpers'
import {EmptyState} from "../EmptyState";
import {ENTITY_TYPES} from "../../EntitySelector/EntitySelector.constants";
import {type SelectedItemsData} from "../../EntitySelector/EntitySelector.types";
import useGetTrails from "../../../hooks/api/useGetTrails";
import {Trail} from "../../../types/Trail";

// Types ----

type TrailsPanelProps = {
  onSelect: (trail: Trail) => void
  selectedItems: SelectedItemsData
  isMaxSelected?: boolean
}

// Component ----

function TrailsPanel({ onSelect, selectedItems, isMaxSelected }: TrailsPanelProps) {
  const {data: trails, isLoading} = useGetTrails({
    perPage: 1000,
  });

  return (
      <PanelWrapper isLoading={isLoading}>
        {isLoading ?
          loadingSkeleton :
          <>
            {!!trails?.data?.length ? trails?.data.map(trail => {
                const selected = isSelected(trail, ENTITY_TYPES.TRAIL, selectedItems);

                return (
                  <Card
                    key={trail.id}
                    onClick={() => onSelect(trail)}
                    heading={trail.name}
                    footer={trail.site?.name}
                    imageUrl={trail.image?.preview_url}
                    active={selected}
                    disabled={isMaxSelected && !selected}
                  />
                )
              }) :
              <EmptyState />
            }
          </>
        }
      </PanelWrapper>
  );
}

export {TrailsPanel};